<template>
  <div class="tab-container">
    <div class="tab-container-header">
      <div class="tab-container-header-lefticon" @click="prev">
        <img
          src="https://image.bookgo.com.cn/bgOfficial/interact/interact-left-icon.png"
          alt=""
        />
      </div>
      <div class="tab-container-header-center">
        <ul
          :style="{
            width: tabList.length * 11.44 + 'rem',
            'margin-left': -num * 11.44 + 'rem',
          }"
        >
          <li
            v-for="(item, i) in tabList"
            :key="i"
            :class="{ isActive: current == i }"
            @click="current = i"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
      <div class="tab-container-header-righticon" @click="next">
        <img
          src="https://image.bookgo.com.cn/bgOfficial/interact/interact-right-icon.png"
          alt=""
        />
      </div>
    </div>
    <div class="tab-container-content">
      <div class="tab-container-content-left">
        <h2>{{ tabList[current].rank }}</h2>
        <h3>{{ tabList[current].title }}</h3>
        <p>{{ tabList[current].desc }}</p>
      </div>
      <div class="tab-container-content-right">
        <img :src="tabList[current].pic" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      current: 0,
      num: 0,
    };
  },
  watch: {
    current(newV, oldV) {
      console.log(newV);
      if (this.tabList.length > 6 && newV == 5) {
        this.num = 1;
      }
    },

    num(newV, oldV) {
      if (newV >= this.tabList.length - 6) {
        this.num = this.tabList.length - 6;
      }
    },
  },
  methods: {
    prev() {
      this.current--;
      this.num--;
      if (this.current <= 0) {
        this.current = 0;
      }
      if (this.num <= 0) {
        this.num = 0;
      }
    },
    next() {
      if (this.current >= 5) {
        this.num++;
      }
      if (this.current < this.tabList.length - 1) {
        this.current++;
      } else {
        this.current = this.tabList.length - 1;
        this.num = this.tabList.length - 6;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-container {
  height: 545px;
  background-color: #fff;
  border-radius: 10px;
  &-header {
    height: 70px;
    border-bottom: 1px solid #e8e8e8;
    .isActive {
      background-color: #3a89f2;
      color: #fff;
    }
    &-lefticon {
      float: left;
      width: 50px;
      height: 70px;
      padding: 20px 10px;
      cursor: pointer;
      img {
        width: 30px;
        height: 30px;
      }
    }
    &-righticon {
      float: right;
      width: 50px;
      height: 70px;
      padding: 20px 10px;
      cursor: pointer;
      img {
        width: 30px;
        height: 30px;
      }
    }
    &-center {
      height: 100%;
      width: 1098px;
      float: left;
      overflow: hidden;
      ul {
        height: 100%;
        float: left;
        width: 100%;
        transition: all 0.3s;
        li {
          float: left;
          width: 183px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 70px;
          color: #2e2e2e;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
  &-content {
    display: flex;
    justify-content: space-between;
    &-left {
      padding-left: 56px;
      padding-top: 128px;
      h2 {
        font-size: 38px;
        font-family: MF YingHua (Noncommercial);
        font-weight: normal;
        line-height: 47px;
        color: #373737;
      }
      h3 {
        font-size: 26px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 41px;
        color: #373737;
      }
      p {
        width: 312px;
        margin-top: 15px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        line-height: 26px;
        color: #949494;
      }
    }
    &-right {
      width: 782px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
